import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { RoomTypeEnum } from '@zaoblako/shared/modules/catalog/enums/room-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link RoomTypeEnum} enumeration values */
export const RoomTypeEnumI18n: EnumI18nInterface<RoomTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [RoomTypeEnum.WAREHOUSE]: 'Склад',
    [RoomTypeEnum.OFFICE_SQUARE_LTE_45]: 'Офис 45 кв.м. -',
    [RoomTypeEnum.OFFICE_SQUARE_GT_45]: 'Офис 45 кв.м. +',
    [RoomTypeEnum.RETAIL]: 'Торговое',
  },
  [I18nLocalesEnum.EN_US]: {
    [RoomTypeEnum.WAREHOUSE]: 'Warehouse',
    [RoomTypeEnum.OFFICE_SQUARE_LTE_45]: 'Office 45 sq.m. -',
    [RoomTypeEnum.OFFICE_SQUARE_GT_45]: 'Office 45 sq.m. +',
    [RoomTypeEnum.RETAIL]: 'Retail',
  },
};
